import React, { useEffect, useState } from 'react';
import { Button, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../../assets/style/Articles.css';
import fallbackImage from '../../assets/img/Cover.png'; // fallback image

const baseUrl = 'https://mis.drtrefi.edu.ph/public/images/articles/';

// Helper: strip HTML
const stripHtmlTags = (html) => {
  if (!html) return '';
  return html.replace(/<\/?[^>]+>/gi, '');
};

// Helper: limit title
const limitTitleWords = (title, wordLimit = 5) => {
  if (!title) return '';
  const words = title.split(' ');
  return words.length > wordLimit
    ? words.slice(0, wordLimit).join(' ') + '...'
    : title;
};

// Helper: format date
const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

const NewsUpdate = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;


    const fetchArticles = async () => {
      try {
        const { data } = await axios.get(
          'https://mis.drtrefi.edu.ph/api/articles?display_site=rtr&limit=8'
        );

        if (!isMounted) return;

        const cleanedArticles =
          data?.results?.map((article) => ({
            ...article,
            body: stripHtmlTags(article.body),
            imageUrl: article.cover_image
              ? article.cover_image.startsWith('http')
                ? article.cover_image
                : `${baseUrl}${article.cover_image}`
              : null
          })) || [];

        setArticles(cleanedArticles);
      } catch (error) {
        console.error('Failed to fetch articles', error);
        if (isMounted) setArticles([]);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchArticles();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleImageError = (e) => {
    if (e.target.src !== fallbackImage) {
      e.target.src = fallbackImage;
    }
  };

  return (
    <>
      <section className="hero">
        <div className="container">
          {loading ? (
            <p>Loading articles...</p>
          ) : articles.length > 0 ? (
            articles.map(
              (
                { short_title: id, title, cover_image, imageUrl, created_at },
                index
              ) => (
                <div className="box" key={id || index}>
                  <div className="img">
                    <Image
                      src={imageUrl || fallbackImage}
                      alt={title || 'Article'}
                      onError={handleImageError}
                      loading="lazy"
                    />
                  </div>

                  <div className="text">
                    <Link to={`/articles/singlepage/${id}`}>
                      <h1 className="titleBg">
                        {limitTitleWords(title?.toUpperCase())}
                      </h1>
                      <h6 className="created-at">
                        Publish Date: {formatDate(created_at)}
                      </h6>
                    </Link>
                  </div>
                </div>
              )
            )
          ) : (
            <p>No articles available.</p>
          )}
        </div>
      </section>

      <div className="loadMore">
        <Button variant="outline-success" href="/articles/News">
          Load More Updates
        </Button>
      </div>
    </>
  );
};

export default NewsUpdate;